import React from "react";
import {useEventContext} from "../../../context/EventContext";
import {useLocaleContext} from "../../../context/LocaleContext";
import {usePlayerContext} from "../../../context/PlayerContext";
import {useStreamContext} from "../../../context/StreamContext";
import {capitalizer} from "../../../../../cp/utils";
import "./style.scss";
import Subtitle from "./Subtitle";

export default ({settings = null}) => {
    const {event} = useEventContext();
    const {getProperty} = useLocaleContext();
    const $locale = useLocaleContext();
    const {currentModule, tabletView} = usePlayerContext();
    const {stream} = useStreamContext();

    if (settings && !settings?.showSubtitle && !settings?.showTitle) {
        return null;
    }

    return (
        <article className={`event-banner ${currentModule && tabletView ? `-hidePageBlock` : ''}`}>
            <div
                className="event-banner__header"
                style={{alignItems: (!!settings && settings?.headerAlign) || 'flex-start'}}
            >
                {
                    (!settings || settings?.showTitle) &&
                    <h1
                        className="event-banner__title"
                        style={{
                            fontSize: (!!settings && settings?.titleSize) ? settings?.titleSize : '',
                            fontWeight: (!!settings && settings?.titleBold) ? 'bold' : 'normal',
                        }}
                    >
                        {settings ? settings[`title${capitalizer($locale.name)}`] : getProperty(event, 'name')}
                    </h1>
                }
                {!!settings && settings?.showSubtitle && (
                    <Subtitle settings={settings} stream={stream} />
                )}
            </div>
        </article>
    );
}
